export default "__VITE_ASSET__9856e467__"